import { Link } from 'react-router-dom';
import { services } from '../../../mocks/homeData';

export default function Services() {
  return (
    <section className="bg-[#080808] py-28" id="services">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
          <div>
            <span className="text-[#FF6B35] text-xs font-black uppercase tracking-[0.2em] mb-3 flex items-center gap-2">
              <span className="w-6 h-px bg-[#FF6B35]" />
              Protection &amp; Enhancement
            </span>
            <h2 className="font-display font-black text-5xl lg:text-6xl text-white leading-[1.05]">
              Premium Auto
              <br />
              <span className="text-[#FF6B35]">Services</span>
            </h2>
          </div>
          <p className="text-gray-400 text-base leading-relaxed max-w-sm">
            From XPEL-certified PPF to professional ceramic coating — every service is delivered with obsessive precision and premium materials.
          </p>
        </div>

        {/* Featured top row: large PPF card + tall card */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 mb-5">
          {/* Large featured */}
          <div className="lg:col-span-2 relative overflow-hidden rounded-2xl min-h-[340px] flex flex-col justify-end p-9 group cursor-pointer">
            <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
              style={{ backgroundImage: "url('https://public.readdy.ai/ai/img_res/523671d94512c76056bc3c5ba266ec51.jpg')" }} />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/98 via-[#050505]/60 to-transparent" />
            <div className="absolute top-0 left-0 right-0 h-0.5 bg-[#FF6B35]" />
            <div className="relative z-10">
              <span className="inline-flex items-center gap-1.5 bg-[#FF6B35] text-white text-xs font-black uppercase tracking-widest px-3 py-1 rounded-full mb-4">
                <span className="w-3 h-3 flex items-center justify-center"><i className="ri-award-fill text-xs" /></span>
                XPEL Certified
              </span>
              <h3 className="font-display font-black text-3xl text-white mb-2">Paint Protection Film</h3>
              <p className="text-gray-300 text-sm leading-relaxed mb-4 max-w-lg">
                The ultimate invisible armor for your vehicle's paint. Self-healing technology absorbs rock chips, scratches, and road debris — backed by a 10-year manufacturer warranty.
              </p>
              <div className="flex flex-wrap gap-2 mb-5">
                {['XPEL ULTIMATE PLUS', 'Self-Healing', '10-Year Warranty', 'Full & Partial Packages'].map((b) => (
                  <span key={b} className="bg-white/10 border border-white/15 text-white/75 text-xs px-3 py-1 rounded-full">{b}</span>
                ))}
              </div>
              <Link to="/services/paint-protection-film"
                className="inline-flex items-center gap-2 bg-[#FF6B35] hover:bg-[#E5501A] text-white font-bold text-sm px-5 py-2.5 rounded-lg transition-colors whitespace-nowrap cursor-pointer">
                Get PPF Quote
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line" /></span>
              </Link>
            </div>
          </div>

          {/* Ceramic Coating tall card */}
          <div className="bg-[#111111] border border-white/10 rounded-2xl p-7 flex flex-col group hover:border-[#FF6B35]/40 transition-all duration-300 border-t-4" style={{ borderTopColor: '#FF6B35' }}>
            <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35]/15 rounded-xl mb-5">
              <i className="ri-sparkling-2-fill text-[#FF6B35] text-2xl" />
            </div>
            <h3 className="font-display font-bold text-xl text-white mb-3">Ceramic Coating</h3>
            <p className="text-gray-400 text-sm leading-relaxed mb-5 flex-1">
              Professional 9H ceramic coating delivers hydrophobic protection, UV resistance, and a jaw-dropping gloss that lasts years.
            </p>
            <ul className="space-y-2 mb-6">
              {['9H Surface Hardness', 'Hydrophobic Shield', 'UV & Oxidation Resistance', '5-Year Durability'].map((b) => (
                <li key={b} className="flex items-center gap-2 text-sm text-gray-400">
                  <span className="w-4 h-4 flex items-center justify-center flex-shrink-0"><i className="ri-check-line text-[#FF6B35] text-sm" /></span>
                  {b}
                </li>
              ))}
            </ul>
            <Link to="/services/ceramic-coating"
              className="inline-flex items-center gap-2 text-[#FF6B35] hover:text-orange-300 font-bold text-sm transition-colors cursor-pointer">
              Learn More
              <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform"><i className="ri-arrow-right-line" /></span>
            </Link>
          </div>
        </div>

        {/* Row 2: 4 equal cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-10">
          {services.slice(2).map((service) => (
            <div key={service.id}
              className="bg-[#111111] border border-white/8 rounded-2xl p-6 flex flex-col group hover:border-[#FF6B35]/30 hover:bg-[#141414] transition-all duration-300 cursor-pointer">
              <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35]/10 rounded-xl mb-4">
                <i className={`${service.icon} text-[#FF6B35] text-xl`} />
              </div>
              <h3 className="font-bold text-base text-white mb-2">{service.title}</h3>
              <p className="text-gray-500 text-xs leading-relaxed mb-4 flex-1">{service.description}</p>
              <Link to={service.link} className="inline-flex items-center gap-1.5 text-[#FF6B35] text-xs font-bold hover:text-orange-300 transition-colors cursor-pointer">
                Learn More
                <span className="w-3 h-3 flex items-center justify-center group-hover:translate-x-0.5 transition-transform"><i className="ri-arrow-right-line" /></span>
              </Link>
            </div>
          ))}
        </div>

        {/* CTA row */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href="#lead-form"
            className="flex items-center gap-2 bg-[#FF6B35] hover:bg-[#E5501A] text-white font-bold px-8 py-4 rounded-xl transition-colors whitespace-nowrap cursor-pointer">
            <span className="w-5 h-5 flex items-center justify-center"><i className="ri-calendar-check-fill" /></span>
            Book a Free Consultation
          </a>
          <a href="tel:+18605550127"
            className="flex items-center gap-2 border border-white/20 hover:border-white/50 text-white font-bold px-8 py-4 rounded-xl transition-colors whitespace-nowrap cursor-pointer">
            <span className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-fill" /></span>
            Call (860) 555-0127
          </a>
        </div>
      </div>
    </section>
  );
}
